<template>
    <transition v-if="show.val">
        <div class="modal-mask" :style="{'zIndex': gv_zIndex.tqPopup}" >
            <div class="lc_center TQ_height_fullScreen">

                <div class="lc_wrapper" >

                    <div class="image" >
                        <img class="closeImg TQ_width_32px TQ_clickable"
                             :style="{'zIndex': gv_zIndex.tqPopup_closeImage, 'maxWidth' : maxWidth}"
                             :src="ass_img_closeRed"
                             @click.stop="m_close_f"
                             v-if="showCloseBtn">
                    </div>

                    <div class="lc_body TQ_maxHeight_bodyFullScreen"
                         @click.stop="() => {}"
                         v-click-out-side="m_close_f"
                         :style="{ 'padding' :padding, height: p_height_s, 'maxWidth' : maxWidth}">
                        <slot ></slot>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    import {ass_img_closeRed} from "@/assets/scripts/Ass_Files";
    import {gv_zIndex} from "@/scripts/S_GlobalVar";

    export default {
        name: "TqPopup",
        props:{
            padding : {
                type : String
            },
            show :{
                type: Object,
                require:true
            },
            clickTwice:{
                type:Boolean
            },
            maxWidth:{
                type:String
            },
            showCloseBtn:{
                type: Boolean,
                default: false
            },
            p_height_s:{
                type: String,
            },
            pe_onCloseDo_f:{
                type:Function
            }

        },
        data(){
            return{
                clickOutsideNum  : 0,
                ass_img_closeRed : ass_img_closeRed,
                gv_zIndex        : gv_zIndex,
            }
        },
        methods:{

            m_close_f(){

                if(!this.clickTwice){
                    this.show.val = false;
                    if(this.pe_onCloseDo_f != null) {this.pe_onCloseDo_f()}
                }

                this.clickOutsideNum++;

                if(this.clickOutsideNum > 1){
                    this.clickOutsideNum = 0
                    this.show.val = false;
                    if(this.pe_onCloseDo_f != null) {this.pe_onCloseDo_f()}
                }
            }
        },

    }
</script>

<style scoped lang="scss">

    .modal-mask {
        position: fixed;    // important, absolute not working in TqApproveBtn in top drop menu
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;

        .lc_center {
            /*height: calc(100vh - var(--topBar_nativeApp));*/
            width: 100vw;
            display: grid;
            place-items:center;
            justify-content: center;

            .lc_wrapper {

                div.image{
                    text-align: right;

                    .closeImg{
                        position: relative;
                        margin-right: -12px;
                        margin-bottom: -24px;
                    }
                }

                .lc_body{
                    /*max-height: calc(100vh - var(--topBar_nativeApp) - var(--topBar) - var(--bottomBar));*/
                    max-width: calc(100vw - 20px);
                    width: calc(100vw - 30px);
                    overflow: auto;
                    padding: 8px;
                    background-color: #fff;
                    border-radius: 5px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
                }
            }
        }
    }


</style>
